import styled, { css } from 'styled-components';
import { BADGES_LAYOUT } from '@/app/components/search/components/NoResults/BadgesContainer/types.ts';

const fixedStyled = css`
  width: 100%;
  position: sticky;
  top: 56px;
  animation: animateOpacity 0.3s ease-out;
  padding-top: 20px;
`;

const baseRowStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

const singleRowStyles = css`
  ${baseRowStyles};
  scroll-snap-type: x mandatory;
  flex-wrap: nowrap;
  overflow: hidden;
  justify-content: unset;
  max-height: 40px;
  max-width: 100%;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  > * {
    scroll-snap-align: start;
  }

  @media (max-width: 767px) {
    overflow-y: hidden;
    overflow-x: scroll;
  }

  @media (min-width: 768px) {
    overflow: hidden;
  }
`;

const multipleRowsStyles = css`
  ${baseRowStyles};
  flex-wrap: wrap;
  align-items: baseline;
`;

const layoutStyles = css<{ layout?: BADGES_LAYOUT }>`
  ${({ layout }) => {
    if (layout === BADGES_LAYOUT.SINGLE_ROW) {
      return css`
        ${singleRowStyles};
      `;
    }

    if (layout === BADGES_LAYOUT.MULTIPLE_ROWS) {
      return css`
        ${multipleRowsStyles};
      `;
    }

    if (layout === BADGES_LAYOUT.MULTIPLE_ROWS_RESET_OWN_ROW) {
      return css`
        ${multipleRowsStyles};
        justify-content: center;

        ${ResetButton} {
          margin-top: 16px;
          flex-basis: 100%;
        }
      `;
    }

    return css`
      margin-top: 20px;
    `;
  }}
`;

export const BadgesContainerStyled = styled.div<{ isFixed?: boolean; layout?: BADGES_LAYOUT }>`
  display: flex;
  flex-direction: row;
  max-width: 100%;
  gap: 8px;

  ${layoutStyles};

  .openx-ui-filters-no-results & {
    justify-content: center;
  }

  button {
    justify-content: center;
  }

  ${({ isFixed }) => isFixed && fixedStyled};

  @media (min-width: 1024px) {
    max-width: calc(100% + 32px);
    margin-left: -16px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const Badge = styled.button`
  background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundPrimarySelected};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.interactive.borderPrimaryDefault};
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  border-radius: 20px;
  padding: 10px 12px 10px 16px;
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.semibold};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: ${({ theme }) => theme.kallisto.font.lineHeight['250']};
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }

  svg {
    margin: unset;
    margin-left: 9px;

    path {
      fill: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
    }
  }
`;

export const ResetButton = styled.button`
  display: flex;
  text-align: center;
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: 19px;
  padding: 10px 8px;
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  border: 0;
  background-color: transparent;
  cursor: pointer;
  white-space: nowrap;
`;

export const BadgeContainerTitle = styled.div`
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  font-size: ${({ theme }) => theme.kallisto.font.size['225']};
  margin-right: auto;
`;
